export const SITE_CONFIG = {
  name: 'Surya Power',
  phone: '+919790987190',
  phoneDisplay: '97909 87190',
  whatsapp: '919790987190',
  email: 'info@suryapower.in',
  address: '1/11, GNT Road, Balaji Nagar, Padiyanallur, Chennai - 600052',
  url: 'https://suryapower.store',
  googleMaps: 'https://maps.app.goo.gl/QuXkBd1WaL5wmmxH8',
};
